import React from "react";
import Modal1 from "../../../../../components/DIsplay/Modal/Modal1";
import Rebook from "../../../../../components/flight/book/Rebook";

function ManageOrderRebookModal({ booking, modal, setModal }) {
  return (
    <div>
      <Modal1
        open={modal.rebook}
        setOpen={(modalState) =>
          setModal((prev) => ({ ...prev, rebook: modalState }))
        }
      >
        <Rebook data={booking} />
      </Modal1>
    </div>
  );
}

export default ManageOrderRebookModal;
